import * as ambassadorWixPortfolioProjectItemsV1ProjectItem from './portfolio-project-items-v1-project-item-project-items.http.js';
import * as ambassadorWixPortfolioProjectItemsV1ProjectItemTypes from './portfolio-project-items-v1-project-item-project-items.types.js';
import * as ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes from './portfolio-project-items-v1-project-item-project-items.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createProjectItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.CreateProjectItemRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.CreateProjectItemRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.CreateProjectItemResponse,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.CreateProjectItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectItemsV1ProjectItem.createProjectItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/portfolio/items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateProjectItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.BulkCreateProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.BulkCreateProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.BulkCreateProjectItemsResponse,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.BulkCreateProjectItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectItemsV1ProjectItem.bulkCreateProjectItems(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/bulk/portfolio/items/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getProjectItem(): __PublicMethodMetaInfo<
  'GET',
  { itemId: string },
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.GetProjectItemRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.GetProjectItemRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.GetProjectItemResponse,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.GetProjectItemResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectItemsV1ProjectItem.getProjectItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/portfolio/items/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listProjectItems(): __PublicMethodMetaInfo<
  'GET',
  { projectId: string },
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.ListProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.ListProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.ListProjectItemsResponse,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.ListProjectItemsResponse
> {
  const payload = { projectId: ':projectId' } as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectItemsV1ProjectItem.listProjectItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/portfolio/projects/{projectId}/items',
    pathParams: { projectId: 'projectId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateProjectItem(): __PublicMethodMetaInfo<
  'PATCH',
  { itemId: string },
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.UpdateProjectItemRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.UpdateProjectItemRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.UpdateProjectItemResponse,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.UpdateProjectItemResponse
> {
  const payload = { item: { id: ':itemId' } } as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectItemsV1ProjectItem.updateProjectItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/api/v1/portfolio/items/{item.id}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateProjectItems(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.BulkUpdateProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.BulkUpdateProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.BulkUpdateProjectItemsResponse,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.BulkUpdateProjectItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectItemsV1ProjectItem.bulkUpdateProjectItems(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/api/v1/bulk/portfolio/items/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteProjectItem(): __PublicMethodMetaInfo<
  'DELETE',
  { itemId: string },
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.DeleteProjectItemRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.DeleteProjectItemRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.DeleteProjectItemResponse,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.DeleteProjectItemResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectItemsV1ProjectItem.deleteProjectItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/api/v1/portfolio/items/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteProjectItems(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.BulkDeleteProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.BulkDeleteProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.BulkDeleteProjectItemsResponse,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.BulkDeleteProjectItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectItemsV1ProjectItem.bulkDeleteProjectItems(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/api/v1/bulk/portfolio/items/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function duplicateProjectItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.DuplicateProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.DuplicateProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.DuplicateProjectItemsResponse,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.DuplicateProjectItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectItemsV1ProjectItem.duplicateProjectItems(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/items/duplicate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateTokenForProjectItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.GenerateTokenForProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.GenerateTokenForProjectItemsRequest,
  ambassadorWixPortfolioProjectItemsV1ProjectItemUniversalTypes.GenerateTokenForProjectItemsResponse,
  ambassadorWixPortfolioProjectItemsV1ProjectItemTypes.GenerateTokenForProjectItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioProjectItemsV1ProjectItem.generateTokenForProjectItems(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/portfolio/project/items/media',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Item as ItemOriginal,
  ItemMetadataOneOf as ItemMetadataOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Image as ImageOriginal,
  ImageType as ImageTypeOriginal,
  ImageTypeWithLiterals as ImageTypeWithLiteralsOriginal,
  CommonImage as CommonImageOriginal,
  Point as PointOriginal,
  UnsharpMasking as UnsharpMaskingOriginal,
  Video as VideoOriginal,
  VideoV2 as VideoV2Original,
  VideoResolution as VideoResolutionOriginal,
  Tags as TagsOriginal,
  Link as LinkOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateProjectItemRequest as CreateProjectItemRequestOriginal,
  CreateProjectItemResponse as CreateProjectItemResponseOriginal,
  BulkCreateProjectItemsRequest as BulkCreateProjectItemsRequestOriginal,
  BulkCreateProjectItemsResponse as BulkCreateProjectItemsResponseOriginal,
  BulkCreateProjectItemResult as BulkCreateProjectItemResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetProjectItemRequest as GetProjectItemRequestOriginal,
  GetProjectItemResponse as GetProjectItemResponseOriginal,
  ListProjectItemsRequest as ListProjectItemsRequestOriginal,
  Paging as PagingOriginal,
  ListProjectItemsResponse as ListProjectItemsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  QueryProjectItemsRequest as QueryProjectItemsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryProjectItemsResponse as QueryProjectItemsResponseOriginal,
  UpdateProjectItemRequest as UpdateProjectItemRequestOriginal,
  UpdateProjectItemResponse as UpdateProjectItemResponseOriginal,
  BulkUpdateProjectItemsRequest as BulkUpdateProjectItemsRequestOriginal,
  MaskedItem as MaskedItemOriginal,
  BulkUpdateProjectItemsResponse as BulkUpdateProjectItemsResponseOriginal,
  BulkUpdateProjectItemResult as BulkUpdateProjectItemResultOriginal,
  DeleteProjectItemRequest as DeleteProjectItemRequestOriginal,
  DeleteProjectItemResponse as DeleteProjectItemResponseOriginal,
  BulkDeleteProjectItemsRequest as BulkDeleteProjectItemsRequestOriginal,
  BulkDeleteProjectItemsResponse as BulkDeleteProjectItemsResponseOriginal,
  BulkDeleteProjectItemResult as BulkDeleteProjectItemResultOriginal,
  CreateProjectGalleryRequest as CreateProjectGalleryRequestOriginal,
  CreateProjectGalleryResponse as CreateProjectGalleryResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  DeletedProjectRestored as DeletedProjectRestoredOriginal,
  DuplicateProjectItemsRequest as DuplicateProjectItemsRequestOriginal,
  DuplicateProjectItemsResponse as DuplicateProjectItemsResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GenerateTokenForProjectItemsRequest as GenerateTokenForProjectItemsRequestOriginal,
  GenerateTokenForProjectItemsResponse as GenerateTokenForProjectItemsResponseOriginal,
  ProjectItemMediaToken as ProjectItemMediaTokenOriginal,
} from './portfolio-project-items-v1-project-item-project-items.types.js';
